import { Outlet } from "react-router-dom";
import { Grid, Layout } from "antd";
import { createStyles } from "antd-style";

import {
  type ErrorBoundryProps,
  GenericErrorBoundry,
} from "@av/components/templates/layouts/errors/error-boundry/GenericErrorBoundry";
import { JobsAppLayoutContent } from "./JobsAppLayoutContent";
import { JobsResponsiveHeader } from "../organisms/JobsResponsiveHeader";
import { JobsWebHeader } from "../organisms/JobsWebHeader";

class RouteErrorBoundry extends GenericErrorBoundry {
  constructor(props: ErrorBoundryProps) {
    super(props);
    this.boundryName = "RouteErrorBoundry";
  }
}

const useStyles = createStyles(({ token, css }) => ({
  page: css`
    min-height: 100vh;
  `,
  headerRow: css`
    width: 100%;
    background: ${token.colorBgContainer};
  `,
  headerShell: css`
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 ${token.paddingLG}px;

    @media (min-width: ${token.screenLG}px) {
      padding: 0 ${token.paddingXL * 2}px;
    }
  `,
}));

export function JobsAppLayout() {
  const { styles } = useStyles();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.lg;

  return (
    <Layout className={styles.page}>
      <div className={styles.headerRow}>
        <div className={styles.headerShell}>
          {isMobile ? <JobsResponsiveHeader /> : <JobsWebHeader />}
        </div>
      </div>
      <JobsAppLayoutContent>
        <RouteErrorBoundry>
          <Outlet />
        </RouteErrorBoundry>
      </JobsAppLayoutContent>
    </Layout>
  );
}
